var _circle, _circle2, _circle3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 44.3999,
    cy: 44,
    r: 44,
    fill: "#E32424"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.15,
    cx: 44.3999,
    cy: 44,
    r: 39,
    fill: "#E32424"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.3999,
    cy: 44,
    r: 34,
    fill: "#E32424"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.8198 43.5142L30.506 32.2001C29.7697 31.4641 29.7697 30.2742 30.506 29.5383C31.2419 28.8023 32.4319 28.8023 33.1678 29.5383L44.4819 40.8524L55.7958 29.5383C56.532 28.8023 57.7216 28.8023 58.4576 29.5383C59.1938 30.2742 59.1938 31.4641 58.4576 32.2001L47.1437 43.5142L58.4576 54.8284C59.1938 55.5643 59.1938 56.7542 58.4576 57.4902C58.0908 57.8573 57.6086 58.0417 57.1267 58.0417C56.6448 58.0417 56.1629 57.8573 55.7958 57.4902L44.4819 46.176L33.1678 57.4902C32.8007 57.8573 32.3188 58.0417 31.8369 58.0417C31.355 58.0417 30.8731 57.8573 30.506 57.4902C29.7697 56.7542 29.7697 55.5643 30.506 54.8284L41.8198 43.5142Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/CrossIcon.e3e7b36aa9fbefc24d3001bffac94680.svg";
export { ForwardRef as ReactComponent };